import * as types from './actionTypes';

export function changeTopBannerAction (topBanner) {
    return {type: types.CHANGE_TOPBANNER, topBanner}
}

export function setBusinessAction (business) {
    return {type: types.SET_BUSINESS, business}
}

export function setSearchKeyAction (search) {
    return {type: types.SET_SEARCH_KEY, search}
}

export function initializeKeyAction () {
    return {type: types.INITIALIZE_SEARCH_KEY}
}